<template>
  <section class="featured">
    <div class="container">
      <a-typography-title :level="1">
        数字人功能演示
      </a-typography-title>
      <div class="box_list">
        <div v-for="(item,index) in expand.list" ref="item" class="item" :class="[`i_${index+1}`,index+1===expand.active?'active':'']">
          <a-typography-title :level="5">
            {{ item.title }}
          </a-typography-title>
          <div class="text" v-for="v in item.text">
            <a-image alt="" :src="v.image" />
            <!-- {{ v.text }} -->
          </div>
        </div>
      </div>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_n_3" @click="clickToAidigitalHuman()" style="width:135px !important">
          免费试用(SaaS)
        </a-button>
        <a-button type="link" class="button_n_3" @click="$FN.JumpDownloadApk()" style="width:135px !important">
          下载客户端
          <AndroidOutlined />
        </a-button>
        <a-button class="button_n_2" type="link" @click="$Store.Page().openModal('modalFormCollection','productAidigitalHuman')">
          联系我们
        </a-button>
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from "@interface/public";
import demo_1_1 from "@resource/image/page/productAidigitalHuman/demo_1_1.png";
import demo_1_2 from "@resource/image/page/productAidigitalHuman/demo_1_2.png";
import demo_1_3 from "@resource/image/page/productAidigitalHuman/demo_1_3.png";
import demo_1_4 from "@resource/image/page/productAidigitalHuman/demo_1_4.png";
import { AndroidOutlined } from '@ant-design/icons-vue';

export default {
  name: "plan_featured",
  components: { AndroidOutlined },
  data(): DataInterface {
    return {
      expand: {
        active: 1,
        list: [
          {
            title: "文生图功能",
            text: [
              {
                image: demo_1_1,
              },
            ],
          },
          {
            title: "图片识别功能",
            text: [
              {
                image: demo_1_2,
              },
            ],
          },
          {
            title: "成语接龙模式",
            text: [
              {
                image: demo_1_3,
              },
            ],
          },
          {
            title: "闯关模式",
            text: [
              {
                image: demo_1_4,
              },
            ],
          },
        ],
      },
    };
  },
  mounted(): void {
    // this.listenMouseOver();
  },
  methods: {
    /**
     * 点击去AI数字人
     */
    clickToAidigitalHuman(): void {
      // location.href = 'https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd';
      open("https://aiavatars-monn34rc.apps.galaxy-future.com/");
    },
    /**
     * 监听鼠标移动
     */
    listenMouseOver(): void {
      this.$refs.item.forEach((v: HTMLElement, i: number) => {
        v.addEventListener(
          "mouseover",
          () => {
            this.expand.active = i + 1;
          },
          false
        );
      });
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "@resource/css/_global.less";

@image: "@{src_image}page/productSchedulX/";
@border: 1px solid @color_14;
@style: width @time, background @time;
.featured {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background: @color_white;
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}
.box_list {
  display: flex;
  align-items: stretch;
  justify-content: center;
  margin-top: 26px;
  h5.ant-typography {
    margin: 0 0 6px;
  }
  .item {
    width: 24%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    border: @border !important;
    .shadow(0 0 20px fade(@color_black, 4));
    height: 380px;
    overflow: hidden;
    .text {
      height: 100%;
      flex: auto;
      display: flex;
      align-items: center;
      :deep(.ant-image) {
        border-radius: 2px;
        overflow: hidden;
        img {
          border-radius: 2px;
          overflow: hidden;
          width: 100%; /* 容器宽度 */
          height: 100%; /* 容器高度 */
          object-fit: contain; /* 按比例缩放，完整展示图片 */
          max-height: 320px;
        }
      }
      :deep(.ant-image-mask) {
        display: none;
      }
    }
    cursor: pointer;
    .transition(@style);
    &:hover {
      background: @color_white;
      width: 31%;
    }
  }
}
.ant-space {
  margin: @margin 0 0;
}
@media screen and (max-width: -1px+@grid_lg) {
  .box_list {
    flex-direction: column;
    align-items: center;
    .item {
      width: 80%;
      &:hover {
        width: 80%;
      }
    }
  }
}
</style>